import { createSlice } from "@reduxjs/toolkit";
import { addAudioAction, deleteAudioAction, listAudioAction, uploadAudioFileAction } from "../../actions/AdminActions/AdminAudioAction";

interface AudioState {
    audioList: any[];
    audioListLoading: boolean;
    audioPagination: {
        totalItems: number;
        totalPages: number;
        currentPage: number;
    } | null;
    uploadLoading: boolean;
    deleteLoading: boolean;
    error: string | null;
}

const initialState: AudioState = {
    audioList: [],
    audioListLoading: false,
    audioPagination: null,
    uploadLoading: false,
    deleteLoading: false,
    error: null,
};

const adminAudioSlice = createSlice({
    name: "adminAudio",
    initialState,
    reducers: {
        clearAudioError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // List Audio
            .addCase(listAudioAction.pending, (state) => {
                state.audioListLoading = true;
            })
            .addCase(listAudioAction.fulfilled, (state, action) => {
                state.audioListLoading = false;
                state.audioList = action.payload.data;
                state.audioPagination = action.payload.pagination;
            })
            .addCase(listAudioAction.rejected, (state, action: any) => {
                state.audioListLoading = false;
                state.error = action.payload?.message || "Something went wrong";
            })
            // Upload Audio
            .addCase(uploadAudioFileAction.pending, (state) => {
                state.uploadLoading = true;
            })
            .addCase(uploadAudioFileAction.fulfilled, (state) => {
                state.uploadLoading = false;
            })
            .addCase(uploadAudioFileAction.rejected, (state, action: any) => {
                state.uploadLoading = false;
                state.error = action.payload?.message || "Something went wrong";
            })
            // Add Audio
            .addCase(addAudioAction.pending, (state) => {
                state.uploadLoading = true;
            })
            .addCase(addAudioAction.fulfilled, (state) => {
                state.uploadLoading = false;
            })
            .addCase(addAudioAction.rejected, (state, action: any) => {
                state.uploadLoading = false;
                state.error = action.payload?.message || "Something went wrong";
            })
            // Delete Audio
            .addCase(deleteAudioAction.pending, (state) => {
                state.deleteLoading = true;
            })
            .addCase(deleteAudioAction.fulfilled, (state) => {
                state.deleteLoading = false;
            })
            .addCase(deleteAudioAction.rejected, (state, action: any) => {
                state.deleteLoading = false;
                state.error = action.payload?.message || "Something went wrong";
            });
    },
});

export const { clearAudioError } = adminAudioSlice.actions;
export default adminAudioSlice.reducer;
